import { hexToRgb, rgbDataURL } from 'corporate-utils';
import { getStrapiMedia } from '../../../utils/media';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import { PersonalizationCardNews } from '../../../models/auto-generated-strapi-types/types/components/PersonalizationCardNews';
import {
  CardImageStyled,
  CardTextStyled,
  CardWrapper,
  DescriptionWrapper,
  LinkTitle,
  TitleWrapper,
} from './CardNewsEvents.style';
import Markdown from 'markdown-to-jsx';
import { NewsEventsConfig } from '../../../models/auto-generated-strapi-types/types/components/NewsEventsConfig';
import { getPersonalizationAllAttributes } from '../../../utils/style';
import { SingleStrapiImage } from '../../../models/domain/interfaces';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';
import Link from 'next/link';

interface BaseCardProps {
  url?: any;
  title: string;
  description: string;
  text: string;
  category: string;
  thumbnail: SingleStrapiImage;
  mobileThumbnail?: SingleStrapiImage;
  coverImage: SingleStrapiImage;
  mobileCoverImage?: SingleStrapiImage;
  overlayColor: string;
  coverTextColor?: string;
  date: string;
  startDate?: string;
  endDate?: string;
  button?: {
    url: string;
    text: string;
    type: string;
    newTab: boolean;
  };
  isPrerenderRequest: boolean;
}

interface CardNewsProps {
  data: {
    id: number;
    attributes: BaseCardProps;
  };
  personalization: PersonalizationCardNews[];
  cols: NewsEventsConfig;
}

const CardNewsEventsComponent: React.FC<CardNewsProps> = ({
  data,
  personalization,
  cols,
}) => {
  return (
    <Link href={data?.attributes?.url || ''} passHref>
      <CardWrapper cols={cols}>
        {data?.attributes?.thumbnail && data?.attributes?.thumbnail?.data && (
          <CardImageStyled>
            <ImageWithFallback
              layout="fill"
              objectFit="cover"
              placeholder="blur"
              blurDataURL={rgbDataURL(
                hexToRgb('ffffff')?.[0],
                hexToRgb('ffffff')?.[1],
                hexToRgb('ffffff')?.[2]
              )}
              src={getStrapiMedia(
                data?.attributes?.thumbnail?.data?.attributes?.url
              )}
              alt={
                data?.attributes?.thumbnail?.data?.attributes
                  ?.alternativeText || ''
              }
              fallbackSrc={DEFAULT_IMAGE}
              isPrerenderRequest={data?.attributes?.isPrerenderRequest}
            />
          </CardImageStyled>
        )}
        <CardTextStyled>
          <TitleWrapper
            personalization={getPersonalizationAllAttributes(
              personalization,
              'title'
            )}
          >
            <Link href={data?.attributes?.url || ''} passHref>
              <LinkTitle>
                <Markdown>{data?.attributes?.title || ''}</Markdown>
              </LinkTitle>
            </Link>
          </TitleWrapper>
          <DescriptionWrapper
            personalization={getPersonalizationAllAttributes(
              personalization,
              'description'
            )}
          >
            <Markdown>{data?.attributes?.description || ''}</Markdown>
          </DescriptionWrapper>
        </CardTextStyled>
      </CardWrapper>
    </Link>
  );
};

export default CardNewsEventsComponent;
